// AUTO-GENERATED SQL Builder (V40 Final) for Refund
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class RefundSql {
  private ast = new SqlAst('Refund', 'refund');
  public readonly main: any = {};

  public guid: SqlField;
  public paymentId: SqlField;
  public bookingId: SqlField;
  public amount: SqlField;
  public gatewayRefundRef: SqlField;
  public reverseAll: SqlField;
  public speed: SqlField;
  public reason: SqlField;
  public status: SqlField;
  public processedDate: SqlField;
  public payment: SqlNavHybrid;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public ledgerEntryList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('refund', 'guid', '', 'id', 'refund_guid');
    this.paymentId = new SqlField('refund', 'paymentId', 'payment', 'id', 'refund_payment');
    this.bookingId = new SqlField('refund', 'bookingId', 'booking', 'id', 'refund_booking');
    this.amount = new SqlField('refund', 'amount', '', 'id', 'refund_amount');
    this.gatewayRefundRef = new SqlField('refund', 'gatewayRefundRef', '', 'id', 'refund_gatewayRefundRef');
    this.reverseAll = new SqlField('refund', 'reverseAll', '', 'id', 'refund_reverseAll');
    this.speed = new SqlField('refund', 'speed', '', 'id', 'refund_speed');
    this.reason = new SqlField('refund', 'reason', '', 'id', 'refund_reason');
    this.status = new SqlField('refund', 'status', '', 'id', 'refund_status');
    this.processedDate = new SqlField('refund', 'processedDate', '', 'id', 'refund_processedDate');
    this.payment = createNavHybrid('refund', 'refund_payment', 'Payment');
    this.booking = createNavHybrid('refund', 'refund_booking', 'Booking');
    this.createdByUser = createNavHybrid('refund', 'refund_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('refund', 'refund_updatedByUser', 'User');
    this.ledgerEntryList = createNavHybrid('refund', 'refund_ledgerEntryList', 'LedgerEntry');
    this.id = new SqlField('refund', 'id', '', 'id', 'refund_id');
    this.isDeleted = new SqlField('refund', 'isDeleted', '', 'id', 'refund_isDeleted');
    this.createdBy = new SqlField('refund', 'createdBy', '', 'id', 'refund_createdBy');
    this.createdDate = new SqlField('refund', 'createdDate', '', 'id', 'refund_createdDate');
    this.updatedBy = new SqlField('refund', 'updatedBy', '', 'id', 'refund_updatedBy');
    this.updatedDate = new SqlField('refund', 'updatedDate', '', 'id', 'refund_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:RefundSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:RefundSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:RefundSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:RefundSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:RefundSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:RefundSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:RefundSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:RefundSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:RefundSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:RefundSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
